import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

export const LENGTH_OF_FREE_TRIAL: { text: string; value: string }[] = [
  { text: '90 days', value: '90' },
  { text: '180 days', value: '180' },
  { text: '270 days', value: '270' },
  { text: '365 days', value: '365' },
];

export interface TrialLengthControlProps {
  name: string;
  id: string;
}

export function TrialLengthControl({
  name,
  id,
}: TrialLengthControlProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label="Length of free trial *"
      name={name}
      id={id}
      options={LENGTH_OF_FREE_TRIAL}
      error={get(errors, name)}
      control={control}
      blockWidth
      rules={{
        required: 'Length of free trial is required',
      }}
    />
  );
}
